// src/encryption/sha256/index.ts
var generateSHA256Hash = async (message) => {
  if (!message || typeof crypto === "undefined") {
    return "";
  }
  const msgUint8 = new TextEncoder().encode(message);
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return hashHex;
};

export {
  generateSHA256Hash
};
//# sourceMappingURL=chunk-XUZSJZTN.mjs.map